/* One native form and the native Sleek slide cart, including the mobile CTA. */
if (!customElements.get('mamata-pdp-controls')) {
  customElements.define('mamata-pdp-controls', class extends HTMLElement {
    connectedCallback() {
      this.main = this.closest('product-info');
      this.form = this.main?.querySelector('form[is="product-form"]');
      this.submit = this.form?.querySelector('button[name="add"]');
      if (!this.submit) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.bar = this.querySelector('.mamata-product-sticky');
      this.button = this.querySelector('[data-sticky-add]');
      this.price = this.querySelector('[data-sticky-price]');
      this.label = this.querySelector('[data-sticky-label]');
      this.error = this.querySelector('[data-sticky-error]');
      this.mobile = matchMedia('(max-width: 767px)');
      this.titleNode = this.main.querySelector('.product__block--title');
      this.nativeTitleSlot = document.createComment('Native product title position');
      this.titleNode?.before(this.nativeTitleSlot);
      const moveTitle = () => {
        if (!this.titleNode) return;
        if (this.mobile.matches) this.main.querySelector('[data-mobile-product-title]').append(this.titleNode);
        else this.nativeTitleSlot.after(this.titleNode);
        this.update();
      };
      this.mobile.addEventListener('change', moveTitle, { signal });
      this.button.addEventListener('click', () => {
        if (this.submit.disabled || this.submit.hasAttribute('aria-disabled')) return;
        this.error.hidden = true;
        this.form.requestSubmit(this.submit);
        // Sleek returns focus here after closing the drawer.
        this.form.lastSubmittedElement = this.button;
      }, { signal });
      document.addEventListener('product-ajax:error', event => {
        if (!this.form.contains(document.activeElement) && this.form.lastSubmittedElement !== this.button) return;
        this.error.textContent = event.detail?.errorMessage || 'Non è stato possibile aggiungere il prodotto. Riprova.';
        this.error.hidden = false;
      }, { signal });
      document.addEventListener('product-ajax:added', () => { this.error.hidden = true; }, { signal });
      document.addEventListener('drawer:handleAfterHide', event => {
        if (event.target.tagName !== 'CART-DRAWER' || event.target.activeElement !== this.button) return;
        // Sleek releases its focus trap before removing modal-show asynchronously.
        this.restoreStickyFocus = true;
        this.update();
      }, { signal });
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.submit, { attributes: true, childList: true, subtree: true });
      const nativePrice = this.main.querySelector('[id^="price-"]');
      if (nativePrice) this.observer.observe(nativePrice, { childList: true, subtree: true });
      this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.intersection = new IntersectionObserver(entries => {
        this.submitVisible = entries[0].isIntersecting;
        this.update();
      }, { threshold: 0 });
      this.intersection.observe(this.submit);
      moveTitle();

    }
    update() {
      if (!this.bar) return;
      const modalOpen = document.body.classList.contains('modal-show');
      const visible = this.mobile.matches && !this.submitVisible && !modalOpen;
      this.bar.hidden = !visible;
      this.bar.inert = !visible;
      if (this.restoreStickyFocus && !modalOpen && !document.querySelector('cart-drawer')?.open) {
        this.restoreStickyFocus = false;
        requestAnimationFrame(() => {
          if (this.isConnected && !document.body.classList.contains('modal-show')) {
            (this.bar.hidden ? this.submit : this.button).focus({ preventScroll: true });
          }
        });
      }
      this.button.disabled = this.submit.disabled || this.submit.hasAttribute('aria-disabled');
      this.label.textContent = this.submit.classList.contains('btn--loading') ? 'Aggiunta…' : this.submit.textContent.trim();
      const price = this.main.querySelector('[id^="price-"] .f-price__sale .f-price-item--sale, [id^="price-"] .f-price__regular .f-price-item--regular');
      if (price) this.price.textContent = price.textContent.trim();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.intersection?.disconnect();
    }
  });
}
